import { ArrowUpDown, Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const ASC = "success_rate";
const DESC = "-success_rate";

interface SuccessRateSortableHeaderProps {
  ordering: string | null;
  onOrderingChange: (ordering: string | null) => void;
  label: string;
}

/**
 * En-tête de colonne "Taux de réussite" câblé au tri serveur (via le store).
 * Cycle : null → -success_rate (desc) → success_rate (asc) → null.
 * Ne passe pas par le tri client-side de react-table (colonne en enableSorting:false).
 */
const SuccessRateSortableHeader = ({
  ordering,
  onOrderingChange,
  label,
}: SuccessRateSortableHeaderProps) => {
  const { t } = useTranslation();
  const isSorted = ordering === ASC || ordering === DESC;

  const handleToggle = () => {
    if (ordering === DESC) onOrderingChange(ASC);
    else if (ordering === ASC) onOrderingChange(null);
    else onOrderingChange(DESC);
  };

  return (
    <div className="flex items-center gap-1">
      <button
        onClick={handleToggle}
        className="flex items-center gap-1 cursor-pointer"
      >
        {label}
        <ArrowUpDown
          className={`ml-1 size-4 ${isSorted ? "text-primary" : "opacity-50"}`}
        />
      </button>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className="size-3.5 text-gray-400" />
          </TooltipTrigger>
          <TooltipContent>
            <p>{t("keys.success_rate_tooltip")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default SuccessRateSortableHeader;
